<template>
  <div v-if="modal" class="modal-busca">
    <div class="conteudo">
      <!-- BOTAO DE FECHAR BUSCA -->
      <button class="fechar" @click="showModal(false)">
        <img src="@/assets/imgs/icone_fechar.svg" />
      </button>
      <!-- TOPO DA BUSCA -->
      <div class="busca">
        <div class="topo">
          <input type="text" placeholder="O que você procura?" v-model="textoBusca" />
          <button @click="toggleBuscaAvancada" :class="buscaAvancada ? 'ativo' : ''">
            <img src="@/assets/imgs/icone_filtrodebusca.svg" />
            <span>Busca Avançada</span>
          </button>
        </div>
        <div class="dicas">
          <p>
            Para buscar matérias através de tags, use “#” antes da palavra. Exemplo: “#conteudosvivo”.
          </p>
        </div>
      </div>

      <!-- FILTROS -->
      <div class="filtro" v-if="buscaAvancada">
        <inputData
          titulo="Período de publicação"
          :value="periodoDePublicacao"
          @change="changePeriodoDePublicacao"
        />
        <inputBuscaTags titulo="TAGs" placeholder="#" :value="tags" @change="changeTags" />
        <!--        <inputChangeRegional-->
        <!--          titulo="Regionais"-->
        <!--          placeholder="#"-->
        <!--          :value="regional"-->
        <!--          @change="changeRegional"-->
        <!--        />-->
        <!--        <inputChangeUfs titulo="UFs" placeholder="#" :value="uf" @change="changeUf" />-->
        <inputChangeCategorias
          titulo="Categorias"
          placeholder="#"
          :value="categoriaId"
          @change="changeCategoria"
        />
        <radioButtonSimples titulo="Se Liga?" :value="seLiga" @change="changeSeLiga" disabled />
        <radioButtonSimples
          titulo="Informe comercial?"
          :value="informeComercial"
          @change="informe"
          v-show="showInforme"
          disabled
        />
        <div v-if="informeOnComp" class="informe">
          <inputData titulo="Vigência" :value="vigencia" @change="changeVigencia" />
          <inputData
            titulo="Prazo de leitura"
            :value="prazoDeLeitura"
            @change="changePrazoDeLeitura"
          />
          <inputLeitura titulo="Leitura" :value="leitura" @change="changeLeitura" disabled />
        </div>
        <div class="linha">
          <button @click="resetBusca">Limpar</button>
          <button @click="fetchNoticias" class="destaque">Filtrar</button>
        </div>
      </div>

      <!-- FILTER RESULTS -->
      <div class="filter-result" v-if="existsNoticias">
        <strong>FILTRO</strong>
        <div class="box">
          Ordenar por data:
          <span
            :disabled="filtroResultado.data_publicacao === 'desc'"
            title="Decrescente"
            @click="filtroResultado.data_publicacao = 'desc'"
          >
            <SvgIcon
              name="icon-sort-desc"
              fill="#fff"
              view-box="0 0 427 427"
              height="14"
              width="auto"
            />
          </span>
          <span
            :disabled="filtroResultado.data_publicacao === 'asc'"
            title="Crescente"
            @click="filtroResultado.data_publicacao = 'asc'"
          >
            <SvgIcon
              name="icon-sort-asc"
              fill="#fff"
              view-box="0 0 427 427"
              height="14"
              width="auto"
            />
          </span>
        </div>
      </div>

      <!-- RESULTADOS -->
      <div class="resultados">
        <div class="loading" v-if="finding">
          <spring-spinner :animation-duration="3000" :size="60" color="#FF920D" />
        </div>
        <div class="card-news" v-for="(materia, matindx) in getNoticias" :key="matindx">
          <div class="icon-fav" @click="setFavorita(materia.id, materia.favorita)">
            <SvgIcon
              v-if="materia.favorita"
              name="icone_favoritos"
              fill="#eb1e5a"
              view-box="0 0 50 48"
              height="14"
              width="auto"
            />
            <SvgIcon
              v-else
              name="icone_favoritos"
              fill="#999"
              view-box="0 0 50 48"
              height="14"
              width="auto"
            />
          </div>

          <router-link
            class="previa-materia"
            :to="{ path: makeUrl(materia) }"
            @click.native="acao()"
          >
            <div class="miniatura">
              <img v-if="materia.imagem" :src="materia.imagem" alt />
              <img v-else src="@/assets/imgs/no-image-portal.jpg" alt="sem imagem" />
            </div>
            <div class="infos">
              <h3>{{ materia.titulo }}</h3>
              <div class="categoria">
                <strong>{{ materia.categoria }}</strong> | {{ materia.data }}
                <span v-if=" materia.dataExpiracao && new Date(materia.dataExpiracao)  < new Date()" class="label-expirado">
                  Expirado
                </span>
              </div>
              <p>{{ materia.resumo | shortWords(50) }}</p>
              <div class="tags">
                <span v-for="(item, idx) in materia.tags" :key="idx">
                  <router-link :to="{ name: 'tags', params: { tag: item.slug } }">
                    {{ item.tag }}
                  </router-link>
                </span>
              </div>
            </div>
          </router-link>
        </div>

        <div class="not-found-content" v-if="notfound">
          <span class="not-found">
            Não foi possível localizar o que você procura...
            <span class="not-found-message">
              Caro usuário, não encontrou o que procurava? Utilize então a busca avançada, utilizando os filtros disponíveis. Verifique também se a matéria é pertinente ao seu canal, regional de atuação. Na dúvida consulte seu Gerente ou envie o e-mail para conteudosvivo.br@telefonica.com .
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SpringSpinner } from 'epic-spinners';
import { debounce, includes, orderBy } from 'lodash';
import env from '@/config/env';
import SvgIcon from '@/components/ui/SvgIcon';

import inputData from '@/components/ui/inputData.vue';
import inputBuscaTags from '@/components/ui/inputBuscaTags.vue';
import inputChangeUfs from '@/components/ui/inputChangeUfs.vue';
import inputChangeCategorias from '@/components/ui/inputChangeCategorias.vue';
import inputChangeRegional from '@/components/ui/inputChangeRegional.vue';
import inputLeitura from '@/components/layout/header/inputLeitura.vue';
import radioButtonSimples from '@/components/ui/radioButtonSimples.vue';

export default {
  name: 'busca',
  components: {
    inputData,
    inputBuscaTags,
    radioButtonSimples,
    inputLeitura,
    SpringSpinner,
    inputChangeUfs,
    inputChangeCategorias,
    inputChangeRegional,
    SvgIcon,
  },
  data() {
    return {
      informeOn: false,
      buscaAvancada: false,
      textoBusca: '',
      filtroResultado: {
        data_publicacao: null,
      },
    };
  },
  watch: {
    palavraChave: function(newPalavra) {
      if (newPalavra === '') {
        this.textoBusca = '';
      }
    },
    textoBusca: function(newPalavra) {
      if (newPalavra !== '') {
        this.deboncedFetchNoticias();
      }
      if (newPalavra === '') {
        this.resetBusca();
      }
    },
  },
  computed: {
    ...mapGetters({
      modal: 'modal/modal',
      noticias: 'search/noticias',
      finding: 'search/finding',
      notfound: 'search/itemNotFound',
      palavraChave: 'search/palavraChave',
      periodoDePublicacao: 'search/periodoDePublicacao',
      seLiga: 'search/seLiga',
      informeComercial: 'search/informeComercial',
      vigencia: 'search/vigencia',
      prazoDeLeitura: 'search/prazoDeLeitura',
      leituraPendente: 'search/leituraPendente',
      confirmadoAutomatico: 'search/confirmadoAutomatico',
      confirmadoManual: 'search/confirmadoManual',
      tags: 'search/tags',
      tagsNome: 'search/tagsNome',
      leitura: 'search/leitura',
      categoriaId: 'search/categoriaId',
      uf: 'search/uf',
      regional: 'search/regional',
      showNotify: 'notificacoes/showNotify',
      showModalCopy: "modalCopyStore/modalShow",
    }),
    existsNoticias() {
      return this.noticias.length > 0;
    },
    getNoticias() {
      if (this.filtroResultado.data_publicacao) {
        return orderBy(
          this.noticias,
          item => {
            const data = item.data;
            return data;
          },
          [this.filtroResultado.data_publicacao],
        );
      }

      return this.noticias;
    },
    informeOnComp() {
      return this.informeOn;
    },
    noticiasComp() {
      return this.noticias;
    },
    showInforme() {
      return env.revista.canal === 1 || (env.revista.canal === 6 && this.showNotify);
    },
  },
  methods: {
    ...mapActions({
      showModal: 'modal/showModal',
      resetBusca: 'search/resetBusca',
      changePalavraChave: 'search/changePalavraChave',
      changeTags: 'search/changeTags',
      changeTagsNome: 'search/changeTagsNome',
      changeSeLiga: 'search/changeSeLiga',
      changePeriodoDePublicacao: 'search/changePeriodoDePublicacao',
      changeInformeComercial: 'search/changeInformeComercial',
      changeVigencia: 'search/changeVigencia',
      changePrazoDeLeitura: 'search/changePrazoDeLeitura',
      fetchNoticias: 'search/fetchNoticias',
      fetchNoticiasES: 'search/fetchNoticiasES',
      retriveTags: 'baseTag/retriveTags',
      changeLeitura: 'search/changeLeitura',
      changeUf: 'search/changeUf',
      changeCategoria: 'search/changeCategoria',
      changeRegional: 'search/changeRegional',
      handleChangeFavoriteInSearch: 'favoritos/handleChangeFavoriteInSearch',
      closeModalCopy: "modalCopyStore/hide",
    }),
    async handleSearch() {
      if (!this.buscaAvancada) {
        await this.changePalavraChave(this.textoBusca);
        await this.appendTagsOfInputKeyWord();
        this.fetchNoticiasES();
      }
    },
    /**
     * Se existir tags na barra de pesquisa principal, adiciona as mesmas a pesquisa.
     */
    async appendTagsOfInputKeyWord() {
      const existsTags = includes(this.palavraChave, '#');

      if (existsTags) {
        const search = this.palavraChave.split('#');
        const tags = search.filter(el => el !== '' && el !== null).map(el => el.trim());
        this.changeTagsNome(tags);
      }
    },
    async resetOrAddTagsOfInputKeyWord() {
      if (this.buscaAvancada) {
        this.changeTags([]);
      } else {
        await this.appendTagsOfInputKeyWord();
      }
    },
    inativeInforme() {
      if (this.informeOn && !this.buscaAvancada) {
        this.informeOn = false;
      }
    },
    toggleBuscaAvancada() {
      this.buscaAvancada = !this.buscaAvancada;

      this.inativeInforme();
      this.resetOrAddTagsOfInputKeyWord();
    },
    informe(value) {
      this.informeOn = value;
      this.changeInformeComercial(value);
    },
    makeUrl(noticia) {
      if (parseInt(noticia.se_liga) === 1 || noticia.se_liga === true) {
        return `/se-liga/${noticia.slug}`;
      } else {
        return `/categoria/${noticia.categoriaSlug}/post/${noticia.slug}`;
      }
    },
    acao() {
      this.showModal(false);
      this.$emit('emitMenu');
    },
    async setFavorita(id, checked) {
      const { error } = await this.handleChangeFavoriteInSearch({
        id,
        checked,
      });
      if (error) return;

      this.noticias.map(item => {
        if (item.id === id) {
          item.favorita = !checked;
        }
      });
    },
  },
  created() {
    this.deboncedFetchNoticias = debounce(this.handleSearch, 800);
  },
  mounted() {
    this.resetBusca();

    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.showModal(false);
        this.resetBusca();

        if (this.showModalCopy) {
          this.closeModalCopy();
        }
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.label-expirado {
  background-color: rgb(6, 72, 158);
  border-radius: 20px;
  font-weight: bold;
  line-height: 20px;
  padding-left: 15px;
  padding-right: 15px;
  margin-left: 5px;

}
.modal-busca {
  @extend %gradiente_twilight;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  overflow-y: overlay;

  & .conteudo {
    width: 980px;
    margin: 0 auto;

    & .fechar {
      position: absolute;
      top: 50px;
      right: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      outline: none;
      background: transparent;
      border: none;
      padding: 0px;
      margin: 0px;
      transition: all 0.2s ease-in-out;

      & img {
        width: 40px;
        height: 40px;
      }
    }

    & .busca {
      display: flex;
      flex-direction: column;

      & .topo {
        display: flex;
        position: relative;
        margin-top: 100px;

        & input {
          width: 100%;
            font-family: 'VivoType';
          font-size: 42px;
          font-weight: 500;
          color: white;
          background: transparent;
          border: 0px;
          padding: 0px;
          padding-bottom: 20px;
          padding-right: 240px;
          outline: none;
          border-bottom: 2px solid rgba(white, 0.35);

          &::placeholder {
            color: white;
            font-weight: bold;
          }
        }

        & button {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          right: 0;
          width: 220px;
          height: 45px;
          outline: none;
          background: transparent;
          border: 2px solid white;
          border-radius: 5px;
          transition: all 0.2s ease-in-out;

          & img {
            filter: grayscale(1) brightness(1000);
            margin-right: 15px;
          }

          & span {
              font-family: 'VivoType';
            font-weight: bold;
            color: white;
            font-size: 16px;
            text-transform: uppercase;
          }

          &:hover {
            background: $cor_amarelo;
            border-color: $cor_amarelo;

            & img {
              filter: none;
            }

            & > span {
              color: $cor_roxo;
            }
          }
        }

        & .ativo {
          background: $cor_amarelo;
          border-color: $cor_amarelo;

          & img {
            filter: none;
          }

          & > span {
            color: $cor_roxo;
          }
        }
      }

      & .dicas {
        font-size: 13px;
        font-weight: 500;
        letter-spacing: 0.035em;

        & p {
          font-style: italic;
          color: white;
          opacity: 0.45;
        }
      }
    }

    & .filtro {
      border-radius: 10px;
      border: 2px solid rgba(white, 0.1);
      margin: 10px 0 0;
      padding: 30px 20px 20px;
      animation: filtros 0.2s linear;
      animation-iteration-count: 1;

      & .informe {
        animation: filtros 0.2s linear;
        animation-iteration-count: 1;
      }

      & .linha {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        margin-top: 20px;

        & button {
          width: 180px;
          height: 40px;
          background: rgba(white, 0);
          border: 1px solid rgba(white, 0.35);
          border-radius: 5px;
          outline: none;
            font-family: 'VivoType';
          font-weight: bold;
          font-size: 16px;
          text-transform: uppercase;
          color: rgba(white, 0.35);
          margin: 0 5px;
          transition: all 0.2s ease-in-out;

          &:hover {
            border: 0px;
            color: $cor_roxo;
            background: $cor_amarelo;
          }
        }

        & .destaque {
          border: 0px;
          color: white;
          background: rgba(white, 0.35);
        }
      }
    }

    .filter-result {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-direction: row;
      font-size: 12px;
      font-family: 'OpenSans';
      color: white;
      & .box {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        & span {
          cursor: pointer;
          user-select: none;
          margin-left: 10px;
          padding: 5px 10px;
          border: 1px solid #fff;
          border-radius: 4px;
          &:disabled {
            pointer-events: none;
            border: 1px solid #666;
          }
        }
      }
    }

    & .resultados {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      height: 55vh;
      /* overflow: hidden;
      overflow-y: overlay; */
      margin-top: 5%;

      & .loading {
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        border-radius: 10px;
      }

      & .not-found-content {
        display: flex;
        flex-direction: column;
        & .not-found {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          color: white;
          font-size: 1.2rem;
          text-align: center;
        }
        & .not-found-message {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          color: white;
          font-size: 0.8rem;
          text-align: center;
          color: #fff;
          opacity: .45;
          font-style: italic;
          margin-top: 32px;
        }
      }


      & .card-news {
        position: relative;
        width: auto;
        height: auto;
        transition: all 0.2s ease-in-out;

        &:hover {
          transform: scale(1.025);
        }
        & .icon-fav {
          position: absolute;
          background: #fff;
          padding: 3px;
          border-radius: 2px;
          top: 0px;
          left: 0px;
          z-index: 2;
          box-shadow: 0 3px 3px rgba(0, 0, 0, 0.3);
          transition: all 0.2s ease-in-out;
          cursor: pointer;
        }

        & .previa-materia {
          display: flex;
          width: 460px;
          padding-bottom: 5px;
          border-bottom: 1px solid rgba(white, 0.1);
          margin-bottom: 30px;
          text-decoration: none;

          & .miniatura {
            min-width: 90px;
            min-height: 60px;
            max-width: 90px;
            max-height: 60px;
            margin-right: 15px;
            border-radius: 3px;
            & img {
              display: block;
              object-fit: cover;
              width: 100%;
              height: 100%;
              border-radius: 3px;
            }
          }

          & .infos {
            display: flex;
            flex-direction: column;

            & h3 {
                font-family: 'VivoType';
              font-weight: bold;
              font-size: 18px;
              line-height: 1.3em;
              color: white;
              margin: 0px;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            & .categoria {
              display: flex;
              width: 100%;
              padding: 5px 0;
              font-size: 12px;
              color: darken(white, 10%);
            }

            & .tags {
              display: flex;
              flex-wrap: wrap;
              width: 100%;
              padding: 5px 0;

              & span {
                color: white;
                background: $cor_rosa;
                padding: 0 5px;
                border-radius: 3px;
                font-size: 10px;
                margin: 3px;
                & a {
                  text-decoration: none;
                  color: white;
                }
              }
            }

            & p {
              font-size: 12px;
              line-height: 1.3em;
              margin: 0px;
              color: white;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
  }
}

@keyframes filtros {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .modal-busca {
    overflow: hidden;
    overflow-y: overlay;

    & .conteudo {
      width: 85vw;

      & .fechar {
        top: 2.5%;
        right: 2.5%;

        & img {
          width: 30px;
          height: 30px;
        }
      }

      & .busca {
        & .topo {
          flex-direction: column;
          margin-top: 10vh;

          & input {
            width: calc(100% - 35px);
            font-size: 18px;
            line-height: 1.7;
            padding-bottom: 10px;
            padding-right: 35px;
          }

          & button {
            width: 30px;
            height: 30px;

            & img {
              width: 15px;
              height: 15px;
              margin-right: 0;
            }

            & span {
              display: none;
            }
          }
        }

        & .dicas {
          display: none;
          font-size: 9px;
        }
      }

      & .filtro {
        border-radius: 5px;
        padding: 20px;

        & .linha {
          & button {
            width: 100px;
            height: 30px;
            font-size: 14px;
          }
        }
      }

      & .resultados {
        height: auto;
        overflow: visible;
        overflow-y: visible;
        margin-top: 10%;

        & .card-news {
          width: 100%;

          & .previa-materia {
            width: 100%;
            max-width: unset;
            padding-bottom: 5px;
            margin-bottom: 20px;

            &:hover {
              transform: none;
            }

            & .miniatura {
              min-width: 70px;
              min-height: 50px;
              max-width: 70px;
              max-height: 50px;
              margin-right: 10px;
              border-radius: 2px;

              & img {
                border-radius: 2px;
              }
            }

            & .infos {
              & h3 {
                font-size: 16px;
              }

              & .categoria {
                padding: 3px 0;

                & span {
                  padding: 0 3px;
                  border-radius: 2px;
                  font-size: 9px;
                  margin-right: 2px;
                }
              }

              & p {
                font-size: 10px;
              }
            }
          }
        }
      }
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .modal-busca {
    & .conteudo {
      & .resultados {
        & .previa-materia {
          width: 48%;
        }
      }
    }
  }
}
</style>
